/** API role id for platform super admin (POST /auth/login → user_details.role). */
export const SUPER_ADMIN_ROLE = '3';

function getUserDetailFromStorage() {
  try {
    const raw = localStorage.getItem('userDetail');
    if (!raw || raw === 'null') return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function isSuperAdmin(userDetail = getUserDetailFromStorage()) {
  if (!userDetail) return false;
  return String(userDetail.role) === SUPER_ADMIN_ROLE;
}

export function getSuperAdminHomePath() {
  return '/super-admin/user-management';
}
